import React from 'react';
import { Link } from 'react-router-dom';
import { LinkedinLogo, InstagramLogo } from '@phosphor-icons/react';

const Footer = () => {
  return (
    <footer className="border-t border-black/5 bg-white" data-testid="main-footer">
      <div className="container mx-auto px-6 md:px-12 lg:px-16 py-16">
        {/* Main Footer Grid */}
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8 lg:gap-12">
          {/* Logo & Description */}
          <div className="col-span-2 md:col-span-2">
            <div className="flex items-center mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_invest-portal-59/artifacts/c24cz0ev_Color%20logo%20-%20no%20background.png" 
                alt="Flippex Logo" 
                className="h-8 w-auto"
              />
            </div>
            <p className="text-foreground-muted mb-6 max-w-xs">
              A better way into real estate. Invest in curated projects starting from €100.
            </p>
            <div className="flex space-x-4">
              <a 
                href="https://www.linkedin.com/company/flippex/" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="h-10 w-10 rounded-full bg-[rgb(var(--background))] flex items-center justify-center text-foreground-muted hover:text-primary hover:bg-primary/10 transition-colors" 
                data-testid="footer-linkedin"
              >
                <LinkedinLogo size={20} weight="regular" />
              </a>
              <a 
                href="#" 
                className="h-10 w-10 rounded-full bg-[rgb(var(--background))] flex items-center justify-center text-foreground-muted hover:text-primary hover:bg-primary/10 transition-colors" 
                data-testid="footer-instagram"
              >
                <InstagramLogo size={20} weight="regular" />
              </a>
            </div>
          </div>

          {/* Invest */}
          <div>
            <h4 className="font-semibold mb-4">Invest</h4>
            <ul className="space-y-3 text-sm">
              <li>
                <Link to="/projects" className="text-foreground-muted hover:text-primary transition-colors flex items-center gap-2">
                  Projects
                  <span className="text-[10px] font-semibold px-1.5 py-0.5 rounded bg-green-500/20 text-green-500 animate-pulse">LIVE</span>
                </Link>
              </li>
              <li>
                <Link to="/marketplace" className="text-foreground-muted hover:text-primary transition-colors flex items-center gap-2">
                  Marketplace
                  <span className="text-[10px] font-semibold px-1.5 py-0.5 rounded bg-primary/10 text-primary">SOON</span>
                </Link>
              </li>
              <li><Link to="/how-it-works" className="text-foreground-muted hover:text-primary transition-colors">How It Works</Link></li>
              <li><Link to="/submit-project" className="text-foreground-muted hover:text-primary transition-colors">For Developers</Link></li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h4 className="font-semibold mb-4">Resources</h4>
            <ul className="space-y-3 text-sm">
              <li><Link to="/news" className="text-foreground-muted hover:text-primary transition-colors">News &amp; Stories</Link></li>
              <li><Link to="/faqs" className="text-foreground-muted hover:text-primary transition-colors">FAQs</Link></li>
              <li><Link to="/legal" className="text-foreground-muted hover:text-primary transition-colors">Legal</Link></li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="font-semibold mb-4">Company</h4>
            <ul className="space-y-3 text-sm">
              <li><Link to="/about" className="text-foreground-muted hover:text-primary transition-colors">About Flippex</Link></li>
              <li><Link to="/contact" className="text-foreground-muted hover:text-primary transition-colors">Contact</Link></li>
            </ul>
          </div>
        </div>

        {/* Bottom row */}
        <div className="mt-16 pt-8 border-t border-black/5 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-foreground-muted">
            © {new Date().getFullYear()} Flippex. All rights reserved.
          </p>
          <div className="flex flex-wrap justify-center gap-6 text-sm text-foreground-muted">
            <Link to="/legal/privacy" className="hover:text-primary transition-colors">Privacy Policy</Link>
            <Link to="/legal/terms" className="hover:text-primary transition-colors">Terms of Service</Link>
            <Link to="/legal/risk" className="hover:text-primary transition-colors">Risk Disclosures</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
